/* em-quick-info.js — v27.2 (26/10/2026), v27.4: thêm Email; đã lưu thì hiện gọn 1 khối tóm tắt + nút Sửa/Lưu nhỏ.
 * v27.8 (26/10/2026): form nằm TRÊN ô tick xác nhận (ngay dưới bảng tóm tắt) để hiện sớm hơn; điện thoại: bước Xem lại gọn lại
 *   (bỏ chữ "Bước cuối" + đoạn giải thích dài — nội dung đã có trong ô tick; bảng tóm tắt sát dòng, bỏ dòng Icon = Không,
 *   ảnh khách 40px, bỏ dòng chú thích dưới ảnh) → thấy đủ Tên thêu/Font/Màu chỉ + form + ô tick không cần cuộn.
 * v27.6 (26/10/2026): bỏ chữ "(không bắt buộc)"; ô địa chỉ = "Địa chỉ (trước sáp nhập)"; Tỉnh/Thành phố là ô chọn (63 tỉnh cũ,
 * trước sáp nhập 2025); email = "Email nhận thông tin đơn hàng, khuyến mãi"; mỗi ô địa chỉ/tỉnh/email chiếm trọn hàng để đọc hết chữ.
 * Form "Thông tin nhận hàng" ở bước Xem lại trước khi đặt (trình thiết kế chữ dmc + vẽ ảnh dmp).
 * Không bắt buộc. Khách nhập SĐT, họ tên, email, địa chỉ, tỉnh/thành → lưu trên máy khách (localStorage) →
 * mọi đường đi tới /checkout (Mua ngay, nút Thanh toán ở giỏ, link /checkout) được đổi thành
 * /checkout?checkout[shipping_address][...]=... để Shopify điền sẵn.
 * Mua ngay: em-tts.js gọi window.emCheckoutUrl(); luồng Dawn (em-tts-fix.js) đi qua window.routes.cart_url (getter bên dưới).
 * Đã thử: Shopify nhận last_name, address1, city, country, phone (dạng +84…) và checkout[email] cho ô liên hệ (email, hoặc SĐT +84 nếu
 * không có email). Ô liên hệ chỉ được điền khi phiên checkout chưa nhớ liên hệ cũ (khách mới) — không ghi đè cái khách đã nhập.
 */
(function () {
  if (window.__emQuickInfo) return; window.__emQuickInfo = 1;
  var KEY = 'emQuickInfo';

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function phoneE164(v) {
    var s = String(v || '').replace(/[\s.\-()]/g, '');
    if (/^\+84\d{9}$/.test(s)) return s;
    if (/^84\d{9}$/.test(s)) return '+' + s;
    if (/^0\d{9}$/.test(s)) return '+84' + s.slice(1);
    return '';
  }
  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); }
  function hasData(o) { return !!(o.phone || o.name || o.email || o.addr || o.city); }
  var PROVINCES = ['Hà Nội', 'Hồ Chí Minh', 'Đà Nẵng', 'An Giang', 'Bà Rịa - Vũng Tàu', 'Bắc Giang', 'Bắc Kạn', 'Bạc Liêu', 'Bắc Ninh', 'Bến Tre', 'Bình Định', 'Bình Dương', 'Bình Phước', 'Bình Thuận', 'Cà Mau', 'Cần Thơ', 'Cao Bằng', 'Đắk Lắk', 'Đắk Nông', 'Điện Biên', 'Đồng Nai', 'Đồng Tháp', 'Gia Lai', 'Hà Giang', 'Hà Nam', 'Hà Tĩnh', 'Hải Dương', 'Hải Phòng', 'Hậu Giang', 'Hòa Bình', 'Hưng Yên', 'Khánh Hòa', 'Kiên Giang', 'Kon Tum', 'Lai Châu', 'Lâm Đồng', 'Lạng Sơn', 'Lào Cai', 'Long An', 'Nam Định', 'Nghệ An', 'Ninh Bình', 'Ninh Thuận', 'Phú Thọ', 'Phú Yên', 'Quảng Bình', 'Quảng Nam', 'Quảng Ngãi', 'Quảng Ninh', 'Quảng Trị', 'Sóc Trăng', 'Sơn La', 'Tây Ninh', 'Thái Bình', 'Thái Nguyên', 'Thanh Hóa', 'Thừa Thiên Huế', 'Tiền Giang', 'Trà Vinh', 'Tuyên Quang', 'Vĩnh Long', 'Vĩnh Phúc', 'Yên Bái'];
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  window.emCheckoutUrl = function () {
    var o = load(), q = [], add = function (k, v) { if (v) q.push('checkout[shipping_address][' + k + ']=' + encodeURIComponent(v)); };
    var ph = phoneE164(o.phone), em = emailOk(o.email) ? String(o.email).trim() : '';
    if (!ph && !em && !o.name && !o.addr && !o.city) return '/checkout';
    if (em || ph) q.push('checkout[email]=' + encodeURIComponent(em || ph));
    add('country', 'VN'); add('last_name', (o.name || '').trim()); add('address1', (o.addr || '').trim());
    add('city', (o.city || '').trim()); add('phone', ph);
    return '/checkout?' + q.join('&');
  };

  /* ---------- đường đi tới checkout ---------- */
  function goCheckout(e) { var u = window.emCheckoutUrl(); if (u === '/checkout') return false; if (e) e.preventDefault(); location.href = u; return true; }
  document.addEventListener('submit', function (e) {
    var f = e.target, sb = e.submitter;
    if (!f || !/\/cart\/?$/.test(f.getAttribute('action') || '')) return;
    if (sb && sb.name === 'checkout') goCheckout(e);
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && /^\/checkout\/?$/.test(a.getAttribute('href'))) goCheckout(e);
  }, true);
  /* Mua ngay qua Dawn: em-tts-fix.js đặt window.routes.cart_url = '/checkout' → trả về link có điền sẵn */
  try {
    var R = window.routes;
    if (R && !R.__emQI) {
      var cu = R.cart_url;
      Object.defineProperty(R, 'cart_url', {
        configurable: true, enumerable: true,
        get: function () { return (typeof cu === 'string' && /^\/checkout\/?$/.test(cu)) ? window.emCheckoutUrl() : cu; },
        set: function (v) { cu = v; }
      });
      R.__emQI = 1;
    }
  } catch (e) {}
  /* lưới an toàn: trình duyệt có Navigation API (Chrome, Safari 26+) — mọi lệnh chuyển tới /checkout trần */
  if (window.navigation && navigation.addEventListener) {
    navigation.addEventListener('navigate', function (e) {
      try {
        var u = new URL(e.destination.url);
        if (u.origin === location.origin && /^\/checkout\/?$/.test(u.pathname) && !u.search && e.cancelable) {
          var to = window.emCheckoutUrl(); if (to !== '/checkout') { e.preventDefault(); location.href = to; }
        }
      } catch (er) {}
    });
  }

  /* ---------- form ở bước Xem lại ---------- */
  var st = document.createElement('style');
  st.textContent =
    '.emq{margin:10px 0 4px;padding:8px 10px 10px;border:1px solid #e6def5;border-radius:12px;background:#fbf9ff}' +
    '.emq__h{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 0 6px}' +
    '.emq__t{margin:0;font-size:12.5px;line-height:1.3;font-weight:600;color:#3a2f55}' +
    '.emq__t small{font-weight:400;color:#8a82a0;font-size:12px}' +
    '.emq__btn{flex:0 0 auto;border:1px solid #cbbcea;background:#fff;color:#7f63bd;font:inherit;font-size:12px;font-weight:600;line-height:1;padding:5px 12px;border-radius:999px;cursor:pointer}' +
    '.emq__btn--save{background:#9b7fd4;border-color:#9b7fd4;color:#fff}' +
    '.emq__sum{margin:0;font-size:13px;line-height:1.45;color:#3a3542}' +
    '.emq__sum span{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.emq__sum span.is-muted{color:#8a82a0}' +
    '.emq.is-view .emq__g,.emq.is-view .emq__e{display:none!important}' +
    '.emq.is-edit .emq__sum{display:none}' +
    '.emq.is-view{padding-bottom:8px}.emq.is-view .emq__h{margin-bottom:2px}' +
    '.emq__g{display:grid;grid-template-columns:1fr 1fr;gap:6px}' +
    '.emq__g input,.emq__g select{width:100%;min-width:0;box-sizing:border-box;height:38px;padding:0 10px;border:1px solid #d9d0ec;border-radius:10px;background:#fff;font:inherit;font-size:16px;color:#222;outline:none}' +
    '.emq__g select{-webkit-appearance:none;appearance:none;padding-right:30px;background-image:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' viewBox=\'0 0 12 8\'><path d=\'M1 1l5 5 5-5\' fill=\'none\' stroke=\'%237f63bd\' stroke-width=\'1.8\' stroke-linecap=\'round\'/></svg>");background-repeat:no-repeat;background-position:right 11px center}' +
    '.emq__g select.is-empty{color:#9a93ad}' +
    '.emq__g input::placeholder{color:#9a93ad}' +
    '.emq__g input:focus,.emq__g select:focus{border-color:#9b7fd4;box-shadow:0 0 0 2px rgba(155,127,212,.18)}' +
    '.emq__g input.is-bad{border-color:#d7262d}' +
    '.emq__g .emq__ph{grid-column:1/2}.emq__g .emq__nm{grid-column:2/3}.emq__g .emq__em{grid-column:1/-1}' +
    '.emq__g .emq__ad{grid-column:1/-1}.emq__g .emq__ct{grid-column:1/-1}' +
    '.emq__e{display:none;margin:6px 0 0;font-size:12px;color:#d7262d}.emq__e.is-on{display:block}' +
    '@media (max-width:749px){.emq__g{grid-template-columns:1fr 1.1fr}.emq__g input,.emq__g select{height:36px;padding:0 9px}.emq__g select{padding-right:28px}.emq__g input::placeholder{font-size:14px}}' +
    /* v27.8: điện thoại — bước Xem lại gọn (áp cho cả thêu tên .dmc và thêu ảnh .dmp) */
    '@media (max-width:749px){' +
    '.dmc-modal.is-confirm .dmc-panel--confirm .dmc-eyebrow,.dmp-modal.is-confirm .dmp-panel--confirm .dmp-eyebrow,' +
    '.dmc-modal.is-confirm .dmc-panel--confirm .dmc-head .dmc-note,.dmp-modal.is-confirm .dmp-panel--confirm .dmp-head .dmp-note{display:none!important}' +
    '.dmc-modal.is-confirm .dmc-panel--confirm .dmc-head,.dmp-modal.is-confirm .dmp-panel--confirm .dmp-head{margin-bottom:6px!important;padding-top:0!important;padding-bottom:0!important}' +
    '.dmc-modal.is-confirm .dmc-panel--confirm .dmc-title,.dmp-modal.is-confirm .dmp-panel--confirm .dmp-title{font-size:17px!important;line-height:1.25!important;margin:0!important}' +
    '.dmc-modal.is-confirm .dmc-recap,.dmp-modal.is-confirm .dmp-recap{margin:0 0 4px!important;row-gap:0!important}' +
    '.dmc-modal.is-confirm .dmc-recap>div,.dmp-modal.is-confirm .dmp-recap>div{padding-top:6px!important;padding-bottom:6px!important;min-height:0!important;align-items:center!important}' +
    '.dmc-modal.is-confirm .dmc-recap dt,.dmp-modal.is-confirm .dmp-recap dt,.dmc-modal.is-confirm .dmc-recap dd,.dmp-modal.is-confirm .dmp-recap dd{font-size:13px!important;line-height:1.35!important;margin:0!important}' +
    '.dmc-modal.is-confirm .dmc-recap>div.em-hide,.dmp-modal.is-confirm .dmp-recap>div.em-hide{display:none!important}' +
    '.dmp-modal.is-confirm .dmp-recap__photo{width:40px!important;height:40px!important;object-fit:cover;border-radius:8px}' +
    '.dmp-modal.is-confirm .dmp-recap dd em{display:none!important}' +
    '.dmc-modal.is-confirm .dmc-check,.dmp-modal.is-confirm .dmp-check{margin:8px 0 0!important;padding:8px 10px!important;font-size:12px!important;line-height:1.35!important}' +
    '.dmc-modal.is-confirm .emq,.dmp-modal.is-confirm .emq{margin:6px 0 0!important}' +
    '}';
  document.head.appendChild(st);

  function summary(o) {
    var l1 = [o.name, o.phone].map(function (x) { return String(x || '').trim(); }).filter(Boolean).join(' · ');
    var l2 = String(o.email || '').trim();
    var l3 = [o.addr, o.city].map(function (x) { return String(x || '').trim(); }).filter(Boolean).join(', ');
    return (l1 ? '<span>' + esc(l1) + '</span>' : '') + (l2 ? '<span class="is-muted">' + esc(l2) + '</span>' : '') + (l3 ? '<span class="is-muted">' + esc(l3) + '</span>' : '');
  }
  function setMode(box, mode) {
    var o = load();
    if (mode === 'view' && !hasData(o)) mode = 'edit';
    box.classList.toggle('is-view', mode === 'view'); box.classList.toggle('is-edit', mode === 'edit');
    var b = box.querySelector('.emq__btn');
    b.textContent = mode === 'view' ? 'Sửa' : 'Lưu';
    b.classList.toggle('emq__btn--save', mode === 'edit');
    b.setAttribute('aria-label', mode === 'view' ? 'Sửa thông tin nhận hàng' : 'Lưu thông tin nhận hàng');
    if (mode === 'view') box.querySelector('.emq__sum').innerHTML = summary(o);
  }
  function build() {
    var o = load(), box = document.createElement('div');
    box.className = 'emq';
    box.innerHTML =
      '<div class="emq__h"><p class="emq__t">Thông tin nhận hàng</p><button type="button" class="emq__btn">Lưu</button></div>' +
      '<p class="emq__sum"></p>' +
      '<div class="emq__g">' +
      '<input data-k="phone" class="emq__ph" type="tel" inputmode="tel" autocomplete="tel" placeholder="Số điện thoại" maxlength="15">' +
      '<input data-k="name" class="emq__nm" type="text" autocomplete="name" placeholder="Họ tên người nhận" maxlength="60">' +
      '<input data-k="email" class="emq__em" type="email" inputmode="email" autocomplete="email" placeholder="Email nhận thông tin đơn hàng, khuyến mãi" maxlength="80">' +
      '<input data-k="addr" class="emq__ad" type="text" autocomplete="street-address" placeholder="Địa chỉ (trước sáp nhập)" maxlength="120">' +
      '<select data-k="city" class="emq__ct is-empty" autocomplete="address-level1" aria-label="Tỉnh/Thành phố"><option value="">Tỉnh/Thành phố</option>' +
      PROVINCES.map(function (p) { return '<option value="' + esc(p) + '">' + esc(p) + '</option>'; }).join('') + '</select>' +
      '</div><p class="emq__e"></p>';
    [].slice.call(box.querySelectorAll('input,select')).forEach(function (i) {
      setVal(i, o[i.dataset.k] || '');
      i.addEventListener(i.tagName === 'SELECT' ? 'change' : 'input', function () {
        var c = load(); c[i.dataset.k] = i.value; save(c);
        if (i.tagName === 'SELECT') i.classList.toggle('is-empty', !i.value);
        if (i.dataset.k === 'phone' || i.dataset.k === 'email') check(box);
      });
      i.addEventListener('blur', function () { if (i.dataset.k === 'phone' || i.dataset.k === 'email') check(box, true); });
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); i.blur(); } });
    });
    box.querySelector('.emq__btn').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (box.classList.contains('is-view')) {
        setMode(box, 'edit');
        var f = box.querySelector('input'); try { f.focus({ preventScroll: true }); } catch (x) { f.focus(); }
        return;
      }
      if (check(box, true)) return; /* còn ô sai → giữ form để khách sửa */
      setMode(box, 'view');
    });
    return box;
  }
  /* ô chọn tỉnh: tỉnh đã lưu trước đây (gõ tay) không có trong danh sách → thêm vào để không mất */
  function setVal(i, v) {
    if (i.tagName === 'SELECT') {
      if (v && ![].some.call(i.options, function (op) { return op.value === v; })) { var op = document.createElement('option'); op.value = op.textContent = v; i.appendChild(op); }
      i.value = v || ''; i.classList.toggle('is-empty', !i.value);
    } else i.value = v;
  }
  /* trả về true nếu còn ô sai */
  function check(box, strict) {
    var ph = box.querySelector('[data-k=phone]'), em = box.querySelector('[data-k=email]');
    var pv = ph.value.trim(), ev = em.value.trim();
    var badP = !!pv && !phoneE164(pv), badE = !!ev && !emailOk(ev);
    if (!strict && badP && pv.replace(/\D/g, '').length < 10) badP = false; /* đang gõ dở */
    if (!strict && badE && ev.indexOf('@') < 0) badE = false;
    ph.classList.toggle('is-bad', badP); em.classList.toggle('is-bad', badE);
    var msg = badP ? 'Số điện thoại chưa đúng (VD: 0901 234 567).' : badE ? 'Email chưa đúng định dạng (VD: ten@gmail.com).' : '';
    var e = box.querySelector('.emq__e'); e.textContent = msg; e.classList.toggle('is-on', !!msg);
    return badP || badE;
  }
  function refresh(box) {
    var o = load();
    [].slice.call(box.querySelectorAll('input,select')).forEach(function (i) { if (document.activeElement !== i) setVal(i, o[i.dataset.k] || ''); });
    check(box, true);
  }
  function mount() {
    [].slice.call(document.querySelectorAll('.dmc-modal.is-confirm, .dmp-modal.is-confirm')).forEach(function (m) {
      var ck = m.querySelector('[data-dmc-agree], [data-dmp-agree]'), lab = ck && (ck.closest('label') || ck);
      if (!lab || !lab.parentNode) return;
      var box = m.__emq;
      if (!box) { box = m.__emq = build(); }
      if (box.nextSibling !== lab || box.parentNode !== lab.parentNode) lab.parentNode.insertBefore(box, lab); /* v27.8: ngay TRÊN ô tick xác nhận (dưới bảng tóm tắt) */
      /* v27.8: điện thoại — dòng "Icon: Không" bỏ cho gọn */
      [].slice.call(m.querySelectorAll('.dmc-recap > div, .dmp-recap > div')).forEach(function (r) {
        var dt = r.querySelector('dt'), dd = r.querySelector('dd');
        if (dt && dd && /^icon$/i.test(dt.textContent.trim()) && /^(không|không có|-)$/i.test(dd.textContent.trim())) r.classList.add('em-hide');
      });
      var lcs = getComputedStyle(lab); /* thẳng lề với ô tick (máy tính: lề 30px, điện thoại: theo theme) */
      if (box.style.marginLeft !== lcs.marginLeft || box.style.marginRight !== lcs.marginRight) { box.style.marginLeft = lcs.marginLeft; box.style.marginRight = lcs.marginRight; }
      /* mỗi lần vào bước Xem lại: đã lưu thông tin (vd. từ sản phẩm trước) → hiện gọn + nút Sửa; chưa có → mở form */
      if (!m.__emqShown) { m.__emqShown = 1; refresh(box); setMode(box, hasData(load()) && !box.querySelector('.is-bad') ? 'view' : 'edit'); }
    });
    [].slice.call(document.querySelectorAll('.dmc-modal:not(.is-confirm), .dmp-modal:not(.is-confirm)')).forEach(function (m) { m.__emqShown = 0; });
  }
  setInterval(mount, 250);
})();
